import type { Tracker } from '../track';
import { Userpilot } from 'userpilot';
import { determinePlan, FREE_PLAN } from '../../../libs/purchase/plan';
import capitalize from 'lodash.capitalize';
import { getProviderName } from '../../../shared/getProviderName';
import { MembershipType } from '../../../services';

const UserpilotTracker: Tracker = {
  id: 'userpilot',

  identify: (user, institution, latestPurchase, rooms, currentPlan) => {
    // No point identifying if we don't know the user
    if (!user) {
      return;
    }

    // TODO: Use currentPlan instead of latestPurchase
    // This will need a complete refactor to reflect new application and billing logic
    // https://doxyme.atlassian.net/browse/PROD-4404
    const plan = latestPurchase
      ? determinePlan(latestPurchase.planId)
      : FREE_PLAN;

    const room = rooms?.find(
      (r) => r.node.membershipType === MembershipType.Owner,
    )?.node;
    const roomSlug = room?.slug || null;

    const userObject = {
      user_id: user.id,
      user_hash: user.hash,
      user_type: 'user',
      name: getProviderName({
        firstName: user.firstName,
        lastName: user.lastName,
      }),
      email: user.email,
      created_at: user.created,
      trialEnd_at: user.trialEndDate,
      betaAccess: user.betaAccesses,
      plan: plan.planId,
      plan_type: currentPlan ? capitalize(currentPlan) : undefined, // Fixes broken data in Userpilot. Bigger rework still required of this file per the to-do above.
      plan_currency: plan.currency,
      plan_version: plan.version,
      plan_period: plan.interval,
      roomSlug,
      specialty: user.speciality,
      institution_id: institution?.id,
      // NOTE: Institution is _always_ null in v2 as all Clinic customers are redirected to v1
      // this is left here so that if/when Clinic is activated on v2 then their details will
      // get sent to userpilot
      company: Boolean(institution?.id)
        ? {
            id: institution?.id,
            name: institution?.name,
            plan: plan.planId,
            created_at: institution?.created,
            seats: latestPurchase?.seats,
          }
        : null,
    };

    Userpilot.identify(user.id.toString(), userObject);
  },

  track: async (event, properties) => {
    Userpilot.track(event, properties);
  },
};

export default UserpilotTracker;
